import React from 'react';

import Right from '@material-ui/icons/ChevronRightRounded';

import { ISource } from '../../store/user/store';

import Button from '../Button';
import CardHeader from '../CardHeader';
import { getPic } from './Utils/getPic';
import AddPaymentIcon from './AddPaymentIcon';

type IconType = 'select' | 'delete';
interface IProps {
  onAdd: () => void;
  onCancel?: () => void;
  onSelect: (token: ISource) => () => void;
  sources: ISource[];
  iconType: IconType;
  textButton?: string;
  selectedCardId?: number;
}

// TODO: Convert to Component to call actions.user.getProfile or ensure it's called before it runs
const CreditCardList = (props: IProps) => {
  const { sources, onSelect, onAdd, onCancel, iconType, textButton, selectedCardId } = props;

  return (
    <>
      <CardHeader label="BILLING INFORMATION" backTo={onCancel} />

      <div className="credit-card-list">
        {sources.map((source: ISource, index) => (
          <Button
            className={`select-button card-item ${
              selectedCardId === source.djstripeId ? 'selected' : ''
            }`}
            id={`card-${source.djstripeId}`}
            key={`card-${index}`}
            style={{ background: 'white' }}
            onClick={onSelect(source)}
          >
            <img src={getPic[source.brand]} alt={`${source.brand} logo`} />

            <div className="card-info-container">
              <span className="type">Credit / Debit Card</span>

              <span className="ending">Ending in {source.last4}</span>
            </div>

            {iconType === 'delete' ? (
              <span className="delete-card-label">DELETE CARD</span>
            ) : (
              <Right color="primary" fontSize="large" />
            )}
          </Button>
        ))}

        <Button
          color="primary"
          variant={
            sources.length > 0 || (sources.length === 0 && !!textButton) ? 'text' : 'contained'
          }
          fullWidth={true}
          onClick={onAdd}
          className={`button ${
            sources.length > 0 || (sources.length === 0 && !!textButton) ? '' : 'button-shadow'
          }`}
        >
          {sources.length > 0 ? (
            <AddPaymentIcon textButton={textButton} title="ADD PAYMENT METHOD" />
          ) : sources.length === 0 && !!textButton ? (
            <AddPaymentIcon textButton={textButton} title="ADD PAYMENT METHOD" />
          ) : (
            <span className="add-payment-basic">
              {!!textButton ? textButton : `ADD PAYMENT METHOD`}
            </span>
          )}
        </Button>
      </div>
    </>
  );
};

export default CreditCardList;
